module.exports = __webpack_public_path__ + "resources/icon-like-active.0ce92342fc90c279.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-footer/img/icon-like-active.png
// module id = 842
// module chunks = 0 1